import { WebExterna } from './../domain/WebExterna';
import { ContenidoPlano } from 'interiores-mapa';
import { Constantes } from './constantes';
import { environment } from '../../environments/environment';
import { Foto } from './Foto';
import { UsuarioFormulario } from './UsuarioFormulario';
export class Contenido {

	IdContenido: string;
	Id: string;
	Elemento: string;
	Titulo: string;
	NombreCorto: string;
	Descripcion: string;
	Url: string;
	HtmlDetalle: string;
	Source: string;
	FechaAlta: Date;
	FechaBaja: Date;
	POSICION_ACTUAL_CONTENIDOS: any[];
	POSICION_ULTIMA_CONTENIDOS: any[];
	X: number;
	Y: number;
	ALA_PLANO: any;
	WebsExternas: WebExterna[];
	ENTIDAD: any;
	usuarios: UsuarioFormulario[];
	Imagen: any;
	ImagenDetalle: any;

	fotoPrincipal: Foto;
	fotosCarrusel: Foto[];

	ElementoAsignado: { Nombre: string, Tipo: string, MostrarEdicion: false, ENTIDAD: any}[];
	Enlaces: Number;
	Favoritos: Number;
	MostrarEdicion: boolean;
	ExpiracionMensaje: string;
	expirado: Number;
	nuevaImagenSeleccionada: any;
	nuevaImagenDetalleSeleccionada: any;
	borrarImagenDetalleSeleccionada: any;
	AudioTexto: string;
	IdAlternativo: string;
	Latitud: number;
	Longitud: number;
	Seccion: string; // Nombre de la seccion
	Ala: string; // Nombre del Ala
	Nivel: string; // Nombre del Nivel
	Localizacion: string; // Para filtro en tabla localizacion
	Tipo: string; // nombre de la TIPOLOGIA_CONTENIDO

	TIPOLOGIA_CONTENIDO: any;
	CONTENIDO_PLANO: ContenidoPlano = ContenidoPlano.createInstance();

	Idiomas: Map<string, ContenidoIdiomaFormulario> = new Map<string, ContenidoIdiomaFormulario>();

	// TODO: tiempo de permanencia en ultima ubicacion si es localizable
	PermaneceDesde: string;
	TiempoDesdeUltimaLocalizacion: string;
	FechaUltimaLocalizacion: Date;

	Actual;
	Ultima;

	constructor() {
		this.usuarios = [];
		this.WebsExternas = [];
		this.ElementoAsignado = [];
		this.Elemento = '';
		this.Titulo = '';
		this.NombreCorto = '';
		this.Descripcion = '';
		this.Url  = '';
		this.HtmlDetalle = '';
		this.FechaAlta = new Date();
		this.FechaBaja = null;
		this.FechaUltimaLocalizacion = new Date();
		this.AudioTexto =  '';
		this.IdAlternativo = '';
		this.Seccion = '';
		this.Tipo = '';
		this.PermaneceDesde='';
		this.POSICION_ACTUAL_CONTENIDOS;
		this.POSICION_ULTIMA_CONTENIDOS;

		this.TIPOLOGIA_CONTENIDO = {};
		this.CONTENIDO_PLANO = ContenidoPlano.createInstance();
	}

	fromNodoPlano(cont: ContenidoPlano): Contenido{

		this.CONTENIDO_PLANO = cont;

		if (this.CONTENIDO_PLANO.ENTIDAD) {
			return this.fromENTIDAD(this.CONTENIDO_PLANO.ENTIDAD);
		}

		return this;
	}

	fromENTIDAD(ENTIDAD: any): Contenido{
		this.ENTIDAD = ENTIDAD;
		this.IdContenido = this.ENTIDAD.Id;
		this.Id = this.ENTIDAD.Id;
		this.Titulo = this.ENTIDAD.Titulo;
		this.NombreCorto = this.ENTIDAD.NombreCorto ? this.ENTIDAD.NombreCorto : '' ;
		this.Descripcion = this.ENTIDAD.Descripcion;
		this.FechaAlta = this.ENTIDAD.FechaAlta;
		this.FechaBaja = this.ENTIDAD.FechaBaja;
		this.FechaUltimaLocalizacion = this.ENTIDAD.FechaUltimaLocalizacion;
		this.POSICION_ACTUAL_CONTENIDOS = this.ENTIDAD.POSICION_ACTUAL_CONTENIDOS;
		this.POSICION_ULTIMA_CONTENIDOS = this.ENTIDAD.POSICION_ULTIMA_CONTENIDOS;
		this.X = this.ENTIDAD.X;
		this.Y = this.ENTIDAD.Y;
		this.HtmlDetalle = this.ENTIDAD.htmlVisualizableDetalle;
		this.ENTIDAD = this.ENTIDAD;
		this.WebsExternas = [];
		this.TIPOLOGIA_CONTENIDO = this.ENTIDAD.TIPOLOGIA_CONTENIDO;
		this.Tipo = this.TIPOLOGIA_CONTENIDO ? this.TIPOLOGIA_CONTENIDO.Nombre : '';
		this.Latitud = this.ENTIDAD.Latitud;
		this.Longitud = this.ENTIDAD.Longitud;
		this.fotosCarrusel = [];
		this.Actual = this.POSICION_ACTUAL_CONTENIDOS.slice(-1);
		if (this.Actual) {
			this.Actual = this.Actual[0];
		}

		this.Ultima = this.POSICION_ULTIMA_CONTENIDOS.slice(-1);
		if (this.Ultima) {
			this.Ultima = this.Ultima[0];
		}

		if (this.ENTIDAD.ALA_PLANO) {
			this.ALA_PLANO = this.ENTIDAD.ALA_PLANO;
			this.Ala = this.ALA_PLANO.Nomobre;

			if (this.ENTIDAD.ALA_PLANO.NIVEL) {
				this.Nivel = this.ALA_PLANO.NIVEL.Nombre;
			}
		}

		this.AudioTexto = this.ENTIDAD.AudioTexto ? this.ENTIDAD.AudioTexto : '';
		this.IdAlternativo = this.ENTIDAD.IdAlternativo ? this.ENTIDAD.IdAlternativo : '';
		const now = new Date();
		const baja = this.FechaBaja ? new Date(this.FechaBaja) : null;
		const alta = new Date(this.FechaAlta);

		// Calculados
		this.expirado = this.getTipoCaducidad(now, baja, alta);
		this.ExpiracionMensaje = this.getEtiquetaCaducidad(now, baja, alta);
		this.ElementoAsignado = this.getAsignaciones(this.ENTIDAD);

		// IDIOMA
		this.ENTIDAD.IDIOMAS.forEach(element => {
			const aux = new ContenidoIdiomaFormulario(element);
			this.Idiomas.set(element.IDIOMA.Codigo, aux);
		});

		// NODOS
		if (this.ENTIDAD.NODODS && this.ENTIDAD.NODODS.length > 0 && this.ENTIDAD.NODODS[this.ENTIDAD.NODODS.length - 1].NODO && this.ENTIDAD.NODODS[this.ENTIDAD.NODODS.length - 1].NODO.SECCION) {
			this.Seccion = this.ENTIDAD.NODODS[this.ENTIDAD.NODODS.length - 1].NODO.SECCION.Nombre;
		}
		else if (this.ENTIDAD.SECCIONES && this.ENTIDAD.SECCIONES.length > 0 && this.ENTIDAD.SECCIONES[0].SECCION){
			this.Seccion = this.ENTIDAD.SECCIONES[0].SECCION.Nombre;
		}
		this.Localizacion = this.Ala + ' ' + this.Nivel + ' ' + this.Seccion;

		// CONTENIDO_WEB_EXTERNAS
		if (this.ENTIDAD.CONTENIDO_WEB_EXTERNAS) {
			this.Enlaces = this.ENTIDAD.CONTENIDO_WEB_EXTERNAS.length;
			this.ENTIDAD.CONTENIDO_WEB_EXTERNAS.forEach(element => {
				const contenidoWebExterna = new WebExterna(element);
				contenidoWebExterna.Nombre = element.Texto;
				contenidoWebExterna.Url = element.url;
				contenidoWebExterna.IdWebExterna = element.Id;
				contenidoWebExterna.ENTIDAD = element;
				this.WebsExternas.push(contenidoWebExterna);
			});
		}
		else{
			this.Enlaces = 0;
		}

		// FOTO
		if (this.ENTIDAD.FOTOS && this.ENTIDAD.FOTOS[0] !== undefined) {
			/*const ultima = this.ENTIDAD.FOTOS.length - 1;

			if (this.ENTIDAD.FOTOS[ultima] && this.ENTIDAD.FOTOS[ultima].UrlFotoExt) {
				this.Imagen = this.ENTIDAD.FOTOS[ultima].UrlFotoExt;
			}
			else if (this.ENTIDAD.FOTOS[ultima] && this.ENTIDAD.FOTOS[ultima].IdFotoExt){
				this.Imagen =  environment.urlBaseFotos + this.ENTIDAD.FOTOS[ultima].IdFotoExt;
			}

			if (this.ENTIDAD.FOTOS[ultima] && this.ENTIDAD.FOTOS[ultima].UrlFotoExt_detalle) {
				this.ImagenDetalle = this.ENTIDAD.FOTOS[ultima].UrlFotoExt_detalle;
			}
			else if (this.ENTIDAD.FOTOS[ultima] && this.ENTIDAD.FOTOS[ultima].IdFotoExt_detalle){
				this.ImagenDetalle =  environment.urlBaseFotos + this.ENTIDAD.FOTOS[ultima].IdFotoExt_detalle;
			}*/

			this.ENTIDAD.FOTOS.forEach(element => {
				const FotoAux = new Foto().fromENTIDAD(element);
				if (FotoAux.Tipo == 1) {
					this.fotosCarrusel.push(FotoAux);
				}
				if (FotoAux.Tipo == 0) {
					this.fotoPrincipal = FotoAux;
					this.Imagen = this.fotoPrincipal.UrlFotoExt;
					this.ImagenDetalle = this.fotoPrincipal.UrlFotoExt_detalle;
				}
			});
		}
		if(this.ENTIDAD.POSICION_ACTUAL_CONTENIDOS){
			this.POSICION_ACTUAL_CONTENIDOS = this.ENTIDAD.POSICION_ACTUAL_CONTENIDOS;
		}
		if(this.ENTIDAD.POSICION_ULTIMA_CONTENIDOS){
			this.POSICION_ULTIMA_CONTENIDOS = this.ENTIDAD.POSICION_ULTIMA_CONTENIDOS;
		}


		return this;
	}


	getAsignaciones(contenido){

		const asignaciones = [];
		const tipoElementoAsignado = [];
		if (contenido.ALAS.length > 0) {
			contenido.ALAS.forEach(elemento => {
				if (elemento.ALA) {
					asignaciones.push(
						{ Nombre: elemento.ALA.Nomobre, Tipo: 'ALA', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
				else {
					asignaciones.push(
						{ Nombre: elemento.IdAla, Tipo: 'ALA', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
			});
		}
		if (contenido.ESPACIOS.length > 0) {
			contenido.ESPACIOS.forEach(elemento => {
				if (elemento.ESPACIO) {
					asignaciones.push(
						{ Nombre: elemento.ESPACIO.Nombre, Tipo: 'ESPACIO', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
				else{
					asignaciones.push(
						{ Nombre: elemento.IdEspacio, Tipo: 'ESPACIO', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
			});
		}
		if (contenido.NIVELES.length > 0) {
			contenido.NIVELES.forEach(elemento => {
				if (elemento.NIVEL) {
					asignaciones.push(
						{ Nombre: elemento.NIVEL.Nombre, Tipo: 'NIVEL', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
				else{
					asignaciones.push(
						{ Nombre: elemento.IdNivel, Tipo: 'NIVEL', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
			});
		}
		if (contenido.NODODS.length > 0) {
			contenido.NODODS.forEach(elemento => {
				if (elemento.NODO) {
					asignaciones.push(
						{ Nombre: elemento.NODO.Nombre, Tipo: 'NODO', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
				else{
					asignaciones.push(
						{ Nombre: elemento.IdNodo, Tipo: 'NODO', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
			});
		}
		if (contenido.SECCIONES.length > 0) {
			contenido.SECCIONES.forEach(elemento => {
				if (elemento.SECCION) {
					asignaciones.push(
						{ Nombre: elemento.SECCION.Nombre, Tipo: 'SECCION', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
				else{
					asignaciones.push(
						{ Nombre: elemento.IdSeccion, Tipo: 'SECCION', MostrarEdicion: false, ENTIDAD: elemento}
					);
				}
			});
		}

		return asignaciones;
	}


	getEtiquetaCaducidad( now: Date, baja: Date, alta: Date){

		let respuesta = '';
		if ( baja === null || baja === undefined ){

			if ( alta.getTime() <= now.getTime()){
				respuesta = 'Activo';
			}
			else{
				const diferencia = this.dayDiff(alta, now) ;
				if (diferencia > 30) {
					respuesta = 'Empieza el ' + alta.toLocaleDateString();
				}
				else {
					respuesta = 'Empieza en ' + diferencia + ' días';
				}
			}
		}
		else {
			// FechaBaja es posterior a hoy y FechaAlta es anterior a hoy
			if ( alta.getTime() < now.getTime() && now.getTime() < baja.getTime() ){
				const diferencia = this.dayDiff(baja, now) ;
				if (diferencia > 60){
					respuesta = 'Activo';
				}
				else if (diferencia > 30) {
					respuesta = 'Expira el ' + baja.toLocaleDateString();
				}
				else {
					respuesta = 'Expira en ' + diferencia + ' días';
				}

			}
			else if ( now.getTime() < alta.getTime() ){
				const diferencia = this.dayDiff(alta, now) ;
				if (diferencia > 30) {
					respuesta = 'Empieza el ' + alta.toLocaleDateString();
				}
				else {
					respuesta = 'Empieza en ' + diferencia + ' días';
				}
			}
			else if ( now.getTime() > baja.getTime()) {
				const diferencia = this.dayDiff(baja, now) ;
				if (diferencia > 30) {
					respuesta = 'Expirado el ' + baja.toLocaleDateString();
				}
				else {
					respuesta = 'Expirado hace ' + diferencia + ' días';
				}
			}

		}


		return respuesta;
	}


    getFullDateCalc(fec: Date){

		let mes = '' + fec.getMonth();
		let dia = '' + fec.getDate();
		if (fec.getMonth() < 10){
			mes = '0' + fec.getMonth();
		}

		if (fec.getDate() < 10){
			dia = '0' + fec.getDate();
		}

		const year = fec.getFullYear();

		return year + '/' + mes + '/' + dia;
	}

	getTipoCaducidad( now: Date, baja: Date, alta: Date){
		let respuesta = 0;
		const EXPIRADO = 0;	// Danger
		const PROXIMO = 1;	// warning
		const EXPIRA = 2;		// Succes
		const ACTIVO = 3;		// normal
		const TODOS = 4;
		const PROXIMOACT = 5;


		if ( baja === null || baja === undefined ){
			if ( this.getFullDateCalc(alta) <= this.getFullDateCalc(now)){
				respuesta = ACTIVO;
			}
			else{
				respuesta = PROXIMOACT;
			}
		}
		else {
			// FechaBaja es posterior a hoy y FechaAlta es anterior a hoy
			if ( alta.getTime() < now.getTime() && now.getTime() < baja.getTime() ){
				const diferencia = this.dayDiff(baja, now) ;
				if (diferencia > 60){
					respuesta = ACTIVO;
				}
				else if (diferencia > 30) {
					// respuesta = EXPIRA;
					respuesta = ACTIVO;
				}
				else {
					// respuesta = PROXIMO;
					respuesta = ACTIVO;
				}
			}
			else if ( this.getFullDateCalc(alta) > this.getFullDateCalc(now) ){
				respuesta = PROXIMOACT;
			}
			else if ( now.getTime() > baja.getTime()) {
				const diferencia = this.dayDiff(baja, now) ;
				if (diferencia > 30) {
					respuesta = EXPIRADO;
				}
				else {
					respuesta = EXPIRADO;
				}
			}
		}

		return respuesta;
	}

	/* ** FUNCIONES VARIAS ** */
	minDiff(firstDate: Date, secondDate: Date) {
		const date2 = secondDate;
		const date1 = firstDate;
		if (date2 !== undefined && date2 !== null && date1 !== undefined && date1 !== null) {
			const timeDiff = Math.abs(date2.getTime() - date1.getTime());
			const diffDays = Math.ceil(timeDiff / (1000));
			return diffDays;
		}
		else {
			return 999;
		}
	}

	hourDiff(firstDate: Date, secondDate: Date) {
		return this.minDiff(firstDate, secondDate) / 3600
	}

	dayDiff(firstDate: Date, secondDate: Date) {
		return this.hourDiff(firstDate, secondDate) / 24;
	}

/*
	dayDiff(firstDate: Date, secondDate: Date) {
		const date2 = secondDate;
		const date1 = firstDate;
		if (date2 !== undefined && date2 !== null && date1 !== undefined && date1 !== null) {
			const timeDiff = Math.abs(date2.getTime() - date1.getTime());
			const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
			return diffDays;
		}
		else {
			return 999;
		}
		/ 24
	}
*/

}


export class ContenidoIdiomaFormulario {

	Codigo: string;
	Nombre: string;
	Descripcion: string;
	htmlVisualizableDetalle: string;
	htmlVisualizableCelda: string;
	AudioTexto: string;
	NombreCorto: string;


	constructor(contenidoIdioma?) {

		if (contenidoIdioma) {

			this.Codigo = contenidoIdioma.IDIOMA.Codigo ? contenidoIdioma.IDIOMA.Codigo : '';
			this.Nombre = contenidoIdioma.Nombre ? contenidoIdioma.Nombre : '';
			this.Descripcion = contenidoIdioma.Descripcion ? contenidoIdioma.Descripcion : '';
			this.htmlVisualizableDetalle = contenidoIdioma.htmlVisualizableDetalle ? contenidoIdioma.htmlVisualizableDetalle : '';
			this.htmlVisualizableCelda = contenidoIdioma.htmlVisualizableCelda ? contenidoIdioma.htmlVisualizableCelda : '';
			this.AudioTexto = contenidoIdioma.AudioTexto ? contenidoIdioma.AudioTexto : '';
			this.NombreCorto = contenidoIdioma.NombreCorto ? contenidoIdioma.NombreCorto : '';
		}
		else{
			this.Codigo = '';
			this.Nombre = '';
			this.Descripcion = '';
			this.htmlVisualizableDetalle = '';
			this.htmlVisualizableCelda = '';
			this.AudioTexto = '';
			this.NombreCorto = '';
		}

	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/Contenido.ts